module.exports = __webpack_public_path__ + "assets/img/security.4b630d22.svg";